var Modernizr = require('../../vendors/modernizr.min');
var $ = require('jquery');
require('jquery-hoverintent');
var _debounce = require('lodash/debounce');
var WS = require('../../scripts/ws.js');
var Dialog = require("./dialog");
var SiteMask = require('./site-mask');

let executed = false;
let intervalId;
const $body = $('body');
const $megaMenu = $('.ws-megamenu');
const $utilityNav = $('.ws-megamenu__utility-nav');
const $mainMegaMenu = $('.ws-megamenu__main');
const mobileMenuBtn = document.querySelector('.ws-megamenu__mobile-menu-btn');
const $mobileMenuBtn = $(mobileMenuBtn);

function toggleMobileMenu(event) {
    $mobileMenuBtn.toggleClass('ws-megamenu__mobile-menu-btn--close');
    $utilityNav.toggleClass('ws-megamenu__utility-nav--open');
    $mainMegaMenu.toggleClass('ws-megamenu__main--open');
    $body.toggleClass('ws-body--mobile-nav-open');

    if ($body.hasClass('ws-body--mobile-nav-open')) {
        Dialog.openDialog($megaMenu, event, null, '');
        $(".ws-megamenu__mobile-menu-btn--close").focus();
    }
    else if ($('.ws-chat-dialog').hasClass('ws-dialog--enabled')) {
        Dialog.closeDialog(event);
        $(".ws-megamenu__mobile-menu-btn").focus();
    }
    else {
        Dialog.closeAllDialogs(event);
        $(".ws-megamenu__mobile-menu-btn").focus();
    }
}

function initMegaMenu() {
    var desktopMq = '(min-width: 992px)';
    var primaryLinkSelectedClass = 'ws-megamenu__primary-link-wrapper--selected';
    var sectionLinkSelectedClass = 'ws-megamenu__section-link-wrapper--selected';

    var $window = $(window);
    var $document = $(document);
    var $skipLinks = $('.ws-skip-link');
    var $sectionLinks = $('.ws-megamenu__section-links > li');
    var $touchSectionLinks = $('.ws-megamenu__section-link-wrapper--has-children > .ws-megamenu__section-link');
    var $primaryLinks = $('.ws-megamenu__primary-links > li');
    var $primaryLinksMobile = ".ws-megamenu__primary-link-mobile";
    var $touchPrimaryLinksDOM = $('.ws-megamenu__primary-link');
    var $touchPrimaryLinks = '.ws-megamenu__primary-link';
    var $columnHeadingLinksDOM = $('.ws-megamenu__column-heading-link');
    var $columnHeadingLinks = '.ws-megamenu__column-heading-link';
    var $column = '.ws-grid__col';
    var $conversionLinksDOM = $('.ws-megamenu__conversion-link');
    var $conversionLinks = '.ws-megamenu__conversion-link';
    var $conversionAccordionLinksDOM = $('.ws-megamenu__conversion-accordion-link');
    var $conversionAccordionLinks = '.ws-megamenu__conversion-accordion-link';
    var $guideSectionLinksDOM = $('.ws-megamenu__section-link');
    var $guideSectionLinks = '.ws-megamenu__section-link';
    var $guideSubSectionLinksDOM = $('.ws-megamenu__sub-section-link');
    var $guideSubSectionLinks = '.ws-megamenu__sub-section-link';
    var $guideViewAllLinksDOM = $('.ws-megamenu__view-all-link');
    var $guideViewAllLinks = '.ws-megamenu__view-all-link';
    var $topArticleLinksDOM = $('.ws-megamenu__grid-item');
    var $topArticleLinks = '.ws-megamenu__grid-item';

    /*
    $segmentationDropdown.on('change keydown', function (event) {
         if ($body.hasClass("ws-click") || event.which === 13) {
             document.location = $segmentationDropdown.val();
         }
    });
    */

    //todo REFACTOR AS COLUMNS BUILT OUT
    if (Modernizr.browsertouch) {
        $touchPrimaryLinksDOM.on('click', function (event) {
            if (Modernizr.mq(desktopMq)) {
                var $target = $(event.currentTarget),
                    $li = $target.parent();

                event.preventDefault();
                event.stopPropagation();

                if (!$li.hasClass(primaryLinkSelectedClass)) {
                    openMegaMenu($li);
                    $document.on('click', clickOutsideMenuHandler);
                } else {
                    closeMegaMenu();
                }
            }
        });

        $touchSectionLinks.on('click', function (event) {
            if (Modernizr.mq(desktopMq)) {
                var $target = $(event.currentTarget),
                    $li = $target.parent();

                if (!$li.hasClass(sectionLinkSelectedClass)) {
                    event.preventDefault();
                    event.stopPropagation();

                    $sectionLinks.removeClass(sectionLinkSelectedClass);
                    $li.addClass(sectionLinkSelectedClass);
                }
            }
        });
    } else {
        $primaryLinks.hoverIntent({
            over: function (event) {
                if (Modernizr.mq(desktopMq)) {
                    openMegaMenu($(event.currentTarget));
                }
            },
            out: function (event) {
                if (Modernizr.mq(desktopMq)) {
                    if ($(event.currentTarget).hasClass(primaryLinkSelectedClass)) {
                        closeMegaMenu();
                    }
                }
            },
            timeout: 500
        });

        $sectionLinks.hoverIntent({
            over: function (event) {
                if (Modernizr.mq(desktopMq)) {
                    $(event.currentTarget).siblings().removeClass(sectionLinkSelectedClass);
                    $(event.currentTarget).addClass(sectionLinkSelectedClass);
                }
            }
        });
    }

    $mobileMenuBtn.on('click', function (event) {
        event.preventDefault();
        toggleMobileMenu(event);
    });

    $window.on('resize', _debounce(function (event) {
        if (Modernizr.mq(desktopMq) && $body.hasClass('ws-body--mobile-nav-open')) {
            toggleMobileMenu(event);
        }
    }, 200));

    $skipLinks.on('click', function (event) {
        event.preventDefault();
        var $target = $($(this).attr('href'));

        if (!Modernizr.mq(desktopMq) && $target.parents(".ws-megamenu__main").length) {
            $mobileMenuBtn.click();
        }

        if (!$target.attr('tabindex')) {
            $target.attr('tabindex', '0');
        }

        $target.focus();
    });

    //todo MIGRATE/REFACTOR/ADD AS NEEDED
    /* --- START: KEYBOARD ACCESSIBILITY --- */

    $touchPrimaryLinksDOM.focus(function (event) {
        if ($body.hasClass("ws-click")) {
            return;
        }
        var $target = $(event.currentTarget),
            $li = $target.parent();
        if (!$li.hasClass(primaryLinkSelectedClass)) {
            openMegaMenu($li);
        }
    });

    $guideSectionLinksDOM.focus(function (event) {
        if ($body.hasClass("ws-click")) {
            return;
        }

        var $target = $(event.currentTarget),
            $li = $target.parent();

        $li.siblings().removeClass(sectionLinkSelectedClass);
        if ($li.hasClass('ws-megamenu__section-link-wrapper--has-children')) {
            $li.addClass(sectionLinkSelectedClass);
        }
    });

    document.addEventListener('focus', function (event) {
        if ($primaryLinks.hasClass(primaryLinkSelectedClass) && !$.contains($mainMegaMenu.get(0), event.target)) {
            closeMegaMenu();
        }
    }, true);

    $touchPrimaryLinksDOM.on('keydown', function (e) {
        if (e.shiftKey || e.altKey) {
            return;
        }

        var $focusedItem = $(e.currentTarget);
        switch (e.which) {
            case 40:
                //down arrow
                e.preventDefault();
                openMegaMenu($focusedItem.parent());
                $focusedItem.parent().find('a' + $columnHeadingLinks).first().focus();
                break;
            case 37:
                //left arrow
                e.preventDefault();
                $focusedItem.closest('li').prev().find('a' + $touchPrimaryLinks).focus();
                break;
            case 39:
                //right arrow
                e.preventDefault();
                $focusedItem.closest('li').next().find('a' + $touchPrimaryLinks).focus();
                break;
            case 32:
                //spacebar
                e.preventDefault();
                if (e.which === 32) {
                    if (!$primaryLinks.hasClass(primaryLinkSelectedClass)) {
                        openMegaMenu($focusedItem.parent());
                    } else {
                        closeMegaMenu();
                    }
                }

                break;
            case 27:
                //escape
                escapeMegaMenu($focusedItem, e);
                break;
            case 13:
                //enter
                if (!Modernizr.mq(desktopMq)) {
                    var $linksUnderParent = $focusedItem.siblings().find('a' + $columnHeadingLinks);
                    $linksUnderParent.attr("tabindex", "");
                    clickLink($focusedItem);
                }

                break;
            default:
                break;
        }
    });

    $columnHeadingLinksDOM.on('keydown', function (e) {
        if (e.shiftKey || e.altKey) {
            return;
        }

        var $focusedItem = $(e.currentTarget);
        switch (e.which) {
            case 38:
                //up arrow
                e.preventDefault();
                $focusedItem.closest('li').find('a' + $touchPrimaryLinks).focus();
                break;
            case 40:
                //down arrow
                e.preventDefault();
                if ($focusedItem.closest('div' + $column).hasClass('ws-megamenu__guide-col')) {
                    $focusedItem.closest('div' + $column).find('a.ws-megamenu__section-link').first().focus();
                }
                else if ($focusedItem.closest('div' + $column).hasClass('ws-megamenu__top-article-col')) {
                    $focusedItem.closest('div' + $column).find('a.ws-megamenu__grid-item').first().focus();
                }
                else {
                    $focusedItem.closest('div' + $column).find('a.ws-megamenu__conversion-link').first().focus();
                }
                break;
            case 37:
                //left arrow
                e.preventDefault();
                $focusedItem.closest('div' + $column).prev().find('a' + $columnHeadingLinks).focus();
                break;
            case 39:
                //right arrow
                e.preventDefault();
                $focusedItem.closest('div' + $column).next().find('a' + $columnHeadingLinks).focus();
                break;
            case 27:
                //escape
                escapeMegaMenu($focusedItem, e);
                break;
            default:
                break;
        }
    });

    $conversionLinksDOM.on('keydown', function (e) {
        if (e.shiftKey || e.altKey) {
            return;
        }

        var $focusedItem = $(e.currentTarget);
        switch (e.which) {
            case 38:
                //up arrow
                e.preventDefault();
                if ($focusedItem.closest('a').prev().length) {
                    $focusedItem.closest('a').prev().focus();
                }
                else {
                    $focusedItem.closest('div' + $column).find('a' + $columnHeadingLinks).focus();
                }
                
                break;
            case 40:
                //down arrow
                e.preventDefault();
                if ($focusedItem.closest('a').next().length) {
                    $focusedItem.closest('a').next().focus();
                }
                else {
                    $focusedItem.closest('div.ws-grid__item').children().last().children().last().find('a' + $conversionAccordionLinks).first().focus();
                }
                break;
            /*
            case 37:
                //left arrow
                e.preventDefault();
                $focusedItem.closest('div' + $column).find('a' + $columnHeadingLinks).focus();
                break;
            */
            case 39:
                //right arrow
                e.preventDefault();
                $focusedItem.closest('div' + $column).next().find('a' + $columnHeadingLinks).focus();
                break;
            case 27:
                //escape
                escapeMegaMenu($focusedItem, e);
                break;
            default:
                break;
        }
    });

    $conversionAccordionLinksDOM.on('keydown', function (e) {
        if (e.shiftKey || e.altKey) {
            return;
        }

        var $focusedItem = $(e.currentTarget);
        switch (e.which) {
            case 38:
                //up arrow
                e.preventDefault();
                if ($focusedItem.closest('a').prev().length) {
                    $focusedItem.closest('a').prev().focus();
                }
                else {
                    $focusedItem.closest('div' + $column).find('a' + $conversionLinks).last().focus();
                }

                break;
            case 40:
                //down arrow
                e.preventDefault();
                if ($focusedItem.closest('a').next().length) {
                    $focusedItem.closest('a').next().focus();
                }
                else {
                    $focusedItem.closest('div' + $column).next().find('a' + $columnHeadingLinks).focus();
                }
                break;
            /*
            case 37:
                //left arrow
                e.preventDefault();
                $focusedItem.closest('div' + $column).find('a' + $columnHeadingLinks).focus();
                break;
            */
            case 39:
                //right arrow
                e.preventDefault();
                $focusedItem.closest('div' + $column).next().find('a' + $columnHeadingLinks).focus();
                break;
            case 27:
                //escape
                escapeMegaMenu($focusedItem, e);
                break;
            default:
                break;
        }
    });
    
    $guideSectionLinksDOM.on('keydown', function (e) {
        if (e.shiftKey || e.altKey) {
            return;
        }

        var $focusedItem = $(e.currentTarget);
        switch (e.which) {
            case 38:
                //up arrow
                e.preventDefault();
                if ($focusedItem.closest('li').prev().find('a' + $guideSectionLinks).length) {
                    $focusedItem.closest('li').prev().find('a' + $guideSectionLinks).focus();
                }
                else {
                    $focusedItem.closest('div' + $column).find('a' + $columnHeadingLinks).focus();
                }

                break;
            case 40:
                //down arrow
                e.preventDefault();
                if ($focusedItem.closest('li').next().find('a' + $guideSectionLinks).length) {
                    $focusedItem.closest('li').next().find('a' + $guideSectionLinks).focus();
                }
                else {
                    $focusedItem.closest('div' + $column).next().find('a' + $columnHeadingLinks).focus();
                }
                break;
            case 37:
                //left arrow
                e.preventDefault();
                $focusedItem.closest('div' + $column).prev().find('a' + $columnHeadingLinks).focus();
                break;
            case 39:
                //right arrow
                e.preventDefault();
                $focusedItem.parent().find('a' + $guideSubSectionLinks).first().focus();
                break;
            case 27:
                //escape
                escapeMegaMenu($focusedItem, e);
                break;
            default:
                break;
        }
    });
    
    $guideSubSectionLinksDOM.on('keydown', function (e) {
        if (e.shiftKey || e.altKey) {
            return;
        }

        var $focusedItem = $(e.currentTarget);
        switch (e.which) {
            case 38:
                //up arrow
                e.preventDefault();
                if ($focusedItem.closest('li').prev().find('a' + $guideSubSectionLinks).length) {
                    $focusedItem.closest('li').prev().find('a' + $guideSubSectionLinks).focus();
                }
                else {
                    $focusedItem.closest('li.ws-megamenu__section-link-wrapper--has-children').find('a' + $guideSectionLinks).focus();
                }

                break;
            case 40:
                //down arrow
                e.preventDefault();
                if ($focusedItem.closest('li').next().find('a' + $guideSubSectionLinks).length) {
                    $focusedItem.closest('li').next().find('a' + $guideSubSectionLinks).focus();
                }
                else if ($focusedItem.closest('div').find('a.ws-megamenu__view-all-link').length) {
                    $focusedItem.closest('div').find('a.ws-megamenu__view-all-link').focus();
                }
                else {
                    $focusedItem.closest('li.ws-megamenu__section-link-wrapper--has-children').next().find('a' + $guideSectionLinks).focus();
                }
                break;
            case 37:
                //left arrow
                e.preventDefault();
                $focusedItem.closest('li.ws-megamenu__section-link-wrapper--has-children').find('a' + $guideSectionLinks).focus();
                break;
            case 39:
                //right arrow
                e.preventDefault();
                $focusedItem.closest('div' + $column).next().find('a' + $columnHeadingLinks).focus();
                break;
            case 27:
                //escape
                escapeMegaMenu($focusedItem, e);
                break;
            default:
                break;
        }
    });

    $guideViewAllLinksDOM.on('keydown', function (e) {
        if (e.shiftKey || e.altKey) {
            return;
        }

        var $focusedItem = $(e.currentTarget);
        switch (e.which) {
            case 38:
                //up arrow
                e.preventDefault();
                if ($focusedItem.parent().find('a.ws-megamenu__third-level-link').length) {
                    $focusedItem.parent().find('a.ws-megamenu__third-level-link').last().focus();
                }
                break;
            case 40:
                //down arrow
                e.preventDefault();
                if ($focusedItem.closest('li.ws-megamenu__section-link-wrapper--has-children').next().find('a' + $guideSectionLinks).length) {
                    $focusedItem.closest('li.ws-megamenu__section-link-wrapper--has-children').next().find('a' + $guideSectionLinks).focus();
                }
                else {
                    $focusedItem.closest('div' + $column).next().find('a' + $columnHeadingLinks).focus();
                }
                break;
            case 37:
                //left arrow
                e.preventDefault();
                $focusedItem.closest('li.ws-megamenu__section-link-wrapper--has-children').find('a' + $guideSectionLinks).focus();
                break;
            case 39:
                //right arrow
                e.preventDefault();
                $focusedItem.closest('div' + $column).next().find('a' + $columnHeadingLinks).focus();
                break;
            case 27:
                //escape
                escapeMegaMenu($focusedItem, e);
                break;
            default:
                break;
        }
    });

    $topArticleLinksDOM.on('keydown', function (e) {
        if (e.shiftKey || e.altKey) {
            return;
        }

        var $focusedItem = $(e.currentTarget);
        switch (e.which) {
            case 38:
                //up arrow
                e.preventDefault();
                if ($focusedItem.parent().prev().find('a' + $topArticleLinks).length) {
                    $focusedItem.parent().prev().find('a' + $topArticleLinks).focus();
                }
                else {
                    $focusedItem.closest('div' + $column).find('a' + $columnHeadingLinks).focus();
                }

                break;
            case 40:
                //down arrow
                e.preventDefault();
                if ($focusedItem.parent().next().find('a' + $topArticleLinks).length) {
                    $focusedItem.parent().next().find('a' + $topArticleLinks).focus();
                }
                else {
                    $focusedItem.closest('li').next().find('a' + $touchPrimaryLinks).focus();
                }
                break;
            case 37:
                //left arrow
                e.preventDefault();
                $focusedItem.closest('div' + $column).prev().find('a' + $columnHeadingLinks).focus();
                break;
            case 39:
                //right arrow
                e.preventDefault();
                $focusedItem.closest('li').next().find('a' + $touchPrimaryLinks).focus();
                break;
            case 27:
                //escape
                escapeMegaMenu($focusedItem, e);
                break;
            default:
                break;
        }
    });

    /* --- END: KEYBOARD ACCESSIBILITY --- */

    function openMegaMenu($target) {
        $primaryLinks.removeClass(primaryLinkSelectedClass);
        $target.addClass(primaryLinkSelectedClass);
        SiteMask.showDesktopNavMask();

        if (WS.isExperienceEditor()) {
            WS.resetChromes();
        }
    }

    function closeMegaMenu() {
        $primaryLinks.removeClass(primaryLinkSelectedClass);
        SiteMask.hide();
        $document.off('click', clickOutsideMenuHandler);

        if (WS.isExperienceEditor()) {
            WS.resetChromes();
        }
    }

    function clickOutsideMenuHandler(event) {
        if (Modernizr.mq(desktopMq)) {
            var $target = $(event.target);

            if (!$target.closest('.ws-megamenu').length) {
                closeMegaMenu();
            }
        }
    }
    //Prevent accordion animation on link click since we're navigating to another page.
    $(document).on("click", $primaryLinksMobile, function () { preventDefault(); });

    $(".ws-megamenu__mobile-link--featured").on("click", function (event) {
        // if the featured link should open a dynamic dropdown instead of redirecting.
        var $dynamicDropdownSibling = $(this).siblings(".ws-megamenu__dynamic-dropdown");
        if ($dynamicDropdownSibling.length) {
            event.preventDefault();
            $dynamicDropdownSibling.toggleClass("ws-megamenu__dynamic-dropdown--show");
            $(this).parent().toggleClass("ws-megamenu__mobile-link--featured--open");
        }
    });

    $(".ws-megamenu__dynamic-dropdown-content__close").on("click", function (event) {
        $(this).closest(".ws-megamenu__dynamic-dropdown").toggleClass("ws-megamenu__dynamic-dropdown--show");
        $(".ws-megamenu__mobile-link--featured").parent().toggleClass("ws-megamenu__mobile-link--featured--open");
    });

    $(".ws-megamenu__nav-link__dynamic-dropdown").focus(function () {
        // if the featured link should open a dynamic dropdown instead of redirecting.
        var $dynamicDropdownSibling = $(this).siblings(".ws-megamenu__dynamic-dropdown");
        if ($dynamicDropdownSibling.length) {
            $dynamicDropdownSibling.toggleClass("ws-megamenu__dynamic-dropdown--show");
            $(this).parent().toggleClass("ws-megamenu__mobile-link--featured--open");
        }
    });

    $(".ws-megamenu__utility-nav-link").focus(function () {
        if (!$(this).parent(".ws-megamenu__utility-nav-link--desktop-only").length) {
            var $utilityDynamicDropdownLink = $utilityNav.children(".ws-megamenu__utility-nav-link--desktop-only");
            $utilityDynamicDropdownLink.children(".ws-megamenu__dynamic-dropdown").removeClass("ws-megamenu__dynamic-dropdown--show");
            $utilityDynamicDropdownLink.removeClass("ws-megamenu__mobile-link--featured--open");
        }
    });
}

function initMegaMenuOnReady(readyCallback) {
    if (executed) {
        clearInterval(intervalId);
        return;
    }
    
    //todo NOT NEEDED UNTIL ASYNC LOADING IS IMPLEMENTED
    // // if the secondary nav is being loaded via ajax, make sure that has completed before initializing the nav JS
    // const $mainMegamenu = $('.ws-megamenu__main');
    // const secondaryNavLoadingViaAjax = $mainMegamenu.data('ws-datasource');
    // const secondaryNavLoaded = $mainMegamenu.data('ws-datasource-loaded');

    // if (!secondaryNavLoadingViaAjax || secondaryNavLoaded) {
        clearInterval(intervalId);
        initMegaMenu();
        executed = true;

        if (typeof readyCallback === 'function') {
            readyCallback();
        }
    // }
}

function startInitInterval(readyCallback) {
    // only allow the interval to be set up once
    if (!executed && !intervalId) {
        intervalId = setInterval(() => initMegaMenuOnReady(readyCallback), 50);
    }
}

$(function () {
    $(".ws-megamenu *").one("click mouseover focus", function (event) {
        startInitInterval(function () {
            // if the mobile menu button was clicked (treated as mouseover on mobile) as the event that initializes the nav, we want to open the menu afterwards
            if (event.target === mobileMenuBtn && (event.type === "click" || (event.type === "mouseover" && Modernizr.browsertouch))) {
                toggleMobileMenu(event);
            }
        });
    });

    $(window).one("scroll", startInitInterval);
});
